import mod from "-!../../../../../../node_modules/babel-loader/lib/index.js!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AnnotationsPanel.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../../../../node_modules/babel-loader/lib/index.js!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AnnotationsPanel.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./src/uScope/js/extensions/annotations/annotations-ui/AnnotationsPanel.vue?vue&type=script&lang=js&
// module id = 124
// module chunks = 0